import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// ─── CURRENT PROMOTION ────────────────────────────────────────────────────
// Edit these values to change the offer. Times are Adelaide time written with
// their UTC offset (+09:30 ACST, +10:30 ACDT once daylight saving starts on
// 4 Oct 2026), so the offer switches on and off at the same moment for every
// visitor, whatever time zone their device is set to.
export const PROMO = {
  name:       'Diwali Festival Offer',
  percent:    20,
  code:       'DIWALI20',             // set to null to hide the code
  appliesTo:  'all curtains, blinds & shutters',
  startsAt:   new Date('2026-10-01T00:00:00+09:30'), // Thu 1 Oct 2026, 12:00 am
  endsAt:     new Date('2026-11-08T23:59:59+10:30'), // Sun 8 Nov 2026 (Diwali), 11:59 pm
  teaserDays: 14,                     // "starts soon" teaser shown this many days before
};
// ──────────────────────────────────────────────────────────────────────────

const DAY = 24 * 60 * 60 * 1000;

/**
 * Where the promotion is at a given moment:
 *   'hidden'   – too early, nothing shown
 *   'upcoming' – teaser counting down to the start
 *   'live'     – offer running, counting down to the end
 *   'ended'    – offer over, nothing shown
 */
export function getPromoPhase(now = Date.now()) {
  const start = PROMO.startsAt.getTime();
  if (now >  PROMO.endsAt.getTime())       return 'ended';
  if (now >= start)                        return 'live';
  if (now >= start - PROMO.teaserDays*DAY) return 'upcoming';
  return 'hidden';
}

/** "1 Oct" / "8 Nov 2026", always as the date in Adelaide */
export const formatPromoDate = (date, withYear = false) =>
  date.toLocaleDateString('en-AU', { day:'numeric', month:'short', ...(withYear && { year:'numeric' }), timeZone:'Australia/Adelaide' });

// Preview a state before it happens, e.g. yndreamcurtains.com/?promo=live
const PREVIEW_PHASES = ['upcoming', 'live'];

/** Promotion state for components, re-checking the clock every `tickMs`. */
export function usePromo(tickMs = 1000) {
  const [params] = useSearchParams();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(t);
  }, [tickMs]);

  const preview = params.get('promo');
  return { now, phase: PREVIEW_PHASES.includes(preview) ? preview : getPromoPhase(now) };
}
